export const isFileEmpty = (file: File) => {
  return file.size === 0;
};
